import { Image } from "react-native";
import { Text } from "react-native-paper";

import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import FollowUpMessage, {
	type FollowUpMessageProps,
} from "../FollowUpMessageList/FollowUpMessage";

export interface ChatStartViewGroupProps {
	image: string;
	followUpMessages?: FollowUpMessageProps[];
	titleText?: string;
	isStarterMessage?: boolean;
}
const ChatStartViewGroup = ({
	image,
	followUpMessages = [],
	titleText,
	isStarterMessage = false,
}: ChatStartViewGroupProps) => {
	const theme = useAppTheme();
	return (
		<Box gap={8} flex={1} justifyContent="center" alignItems="center">
			{image && isStarterMessage && (
				<>
					<Box
						paddingVertical={24}
						gap={10}
						alignItems="center"
						justifyContent="center"
					>
						<Image
							source={{ uri: image }}
							style={{
								borderRadius: 999,
								width: isStarterMessage ? 90 : 116,
								height: isStarterMessage ? 90 : 116,
							}}
						/>
					</Box>
					<Box alignItems="center" paddingHorizontal={16}>
						<Text
							variant="titleLarge"
							style={{
								color: theme.colors.onSurfaceVariant,
								textAlign: "center",
							}}
						>
							{titleText?.split("**").map((segment, index) => (
								<Text
									key={segment}
									variant="titleMedium"
									style={{
										textAlign: "center",
										color:
											index % 2 === 1
												? theme.colors.onSurface
												: theme.colors.onSurfaceVariant,
										fontWeight: index % 2 === 1 ? "bold" : "normal",
									}}
								>
									{segment}
								</Text>
							))}
						</Text>
					</Box>
				</>
			)}
			<Box
				gap={8}
				paddingTop={image && isStarterMessage ? 32 : 0}
				flexDirection={isStarterMessage ? "row" : "column"}
				flexWrap={isStarterMessage ? "wrap" : "nowrap"}
				justifyContent={isStarterMessage ? "center" : undefined}
				width={isStarterMessage ? undefined : "100%"}
			>
				{followUpMessages?.map((followUpMessage) => (
					<Box key={followUpMessage.message} maxWidth={"100%"}>
						<FollowUpMessage
							{...followUpMessage}
							type={isStarterMessage ? "starterMessage" : "default"}
						/>
					</Box>
				))}
			</Box>
		</Box>
	);
};

export default ChatStartViewGroup;
